<ng-container *ngIf="show">
  <span class="unsaved-dot" title="Modifications non enregistrées"></span>
  <i
    *ngIf="saver"
    class="pi save-all"
    [ngClass]="saver.saving ? 'pi-spin pi-spinner' : 'pi-save'"
    (click)="save($event)"
    title="Tout enregistrer"
  ></i>
</ng-container>
